@if (formFields?.length > 0) {
<form [formGroup]="form" class="govuk-form">

  @for (field of formFields; track $index) {
  @if (field.show_on_this_page) {

  <div [attr.field-name]="field.field" [attr.field]="field | json" [ngClass]="{
      'govuk-form-group': true,
      'govuk-form-group--error':
        form.get(field.field)?.invalid &&
        (form.get(field.field)?.touched || form.get(field.field)?.dirty),
      'hidden-field':
        field.hidden_field || (field.rules_count > 0 && !field.is_visible) || field.lookupValidated
    }">

    <ng-container *ngIf="formBuilder.shouldShowConditional(formId, field, form)">

      <ng-container *ngIf="
          field.type !== 'checkbox' &&
          field.type !== 'radio' &&
          field.type !== 'dropdown' &&
          field.type !== 'heading' &&
          field.type !== 'submit'
        ">
        <p class="govuk-label-wrapper">
          <label class="govuk-label govuk-label--m govuk-label--m--inverse" [for]="field.field">
            {{ displayTitle(field) }}
            <ng-container *ngIf="field.required && showRequiredAsterisk"> *</ng-container>
          </label>
        </p>

        <ng-container *ngIf="field.helptext">
          <div id="{{ field.field }}-hint" class="govuk-hint" [innerHTML]="field.helptext"></div>
        </ng-container>

        @if (showErrors(field['field'])) {
        <div id="{{ field['field'] }}-error" role="alert">
          <p class="govuk-error-message" *ngFor="let errorKey of errorKeys(field['field'])">
            <span class="govuk-visually-hidden">Error:</span>
            {{ getErrorMessage(errorKey, field['field']) }}
          </p>
        </div>
        }

        @if (
        field.type === 'text' ||
        field.type === 'date' ||
        field.type === 'number' ||
        field.type === 'email'
        ) {
        @if(field.address_lookup) {
        <div class="govuk-button-group address-lookup">
          <div class="govuk-input__wrapper">
            <!-- <div class="govuk-input__prefix" aria-hidden="true"> <mat-icon aria-hidden="false" aria-label="A globe showing a home" fontIcon="globe_location_pin"></mat-icon> </div> -->
            <input [id]="field.field" [type]="field.type" [ariaRequired]="field.required"
              formControlName="{{ field.field }}_postcode" [attr.aria-describedby]="describedBy(field)"
              [attr.aria-invalid]="showErrors(field['field']) ? true : null"
              [ngClass]="{ 'govuk-input': true, 'govuk-input--error': !form.pristine && form.get(field.field)?.touched && form.get(field.field)?.errors }" />
          </div>
          <button class="govuk-button govuk-button--secondary find-address" type="button" data-module="govuk-button"
            [disabled]="field.addressLoading"
            (click)="formBuilder.getAddress(formId, field.field, appConfig)">
            {{ field.addressLoading ? 'Searching...' : 'Find address' }}
          </button>
        </div>
        <!-- <div> {{ field.addresses | json }} </div> -->
        <div *ngIf="field.addresses || field.answer">
          <div class="govuk-form-group" *ngIf="field.addresses?.length > 0">
            <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse" for="addresses">
              Select address below
            </label>
            <select [attr.aria-required]="field.required ? 'true' : null"
              (change)="formBuilder.setAddress($event, formId, field) " formControlName="{{ field.field }}"
              class="govuk-select govuk-select--inverse" id="addresses" name="addresses">
              <!-- Hidden placeholder shown only when no value is selected -->
              <option value="" disabled selected hidden>Select address</option>
              <ng-container *ngFor="let option of field['addresses']">
                <option [value]="option.address.ADDRESS">
                  {{ option.address['ADDRESS'] }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>
        } @else if(field.lookup?.aws_table) {
        <div class="aws-lookup">
          <!-- Input and button only shown when not yet validated -->
          <ng-container *ngIf="!field.lookupSuccess">
            <div class="govuk-input__wrapper">
              <input [id]="field.field" [type]="field.type" [ariaRequired]="field.required"
                formControlName="{{ field.field }}" [attr.aria-describedby]="describedBy(field)"
                [attr.aria-invalid]="field['lookupError'] || showErrors(field['field']) ? true : null"
                [ngClass]="{ 'govuk-input': true, 'govuk-input--error': field.lookupError || (!form.pristine && form.get(field.field)?.touched && form.get(field.field)?.errors) }" />
            </div>

            <div class="govuk-button-group">
              <button class="govuk-button govuk-button--secondary lookup-reference" type="button" data-module="govuk-button"
                [disabled]="field.lookupLoading"
                (click)="formBuilder.getAwsLookup(formId, field.field, appConfig)">
                {{ field.lookupLoading ? 'Checking...' : 'Check reference' }}
              </button>
            </div>
          </ng-container>

          <!-- Loading indicator -->
          <div *ngIf="field.lookupLoading" class="govuk-hint">
            Checking reference...
          </div>

          <!-- Error messages -->
          <div *ngIf="field['lookupError'] || field['lookupUsed'] || field['lookupNameMismatch']"
            id="{{ field['field'] }}-lookup-error" role="alert">
            <p *ngIf="field.lookupError && !field.lookupUsed && !field.lookupNameMismatch" class="govuk-error-message">
              <span class="govuk-visually-hidden">Error:</span>
              Reference not found. Please check and try again.
            </p>
            <p *ngIf="field.lookupUsed" class="govuk-error-message">
              <span class="govuk-visually-hidden">Error:</span>
              This reference has already been used.
            </p>
            <p *ngIf="field.lookupNameMismatch" class="govuk-error-message">
              <span class="govuk-visually-hidden">Error:</span>
              The name does not match the reference. Please check and try again.
            </p>
          </div>

          <!-- Success display with Clear button inside -->
          <div *ngIf="field.lookupSuccess && field.lookupResponse" class="govuk-inset-text">
            <p class="govuk-body"><strong>Valid reference number found, please continue.</strong></p>
            <p class="govuk-body" *ngIf="field.lookupResponse.name">Name: {{ field.lookupResponse.name }}</p>
            <p class="govuk-body" *ngIf="field.lookupResponse.home_office">Reference: {{ field.lookupResponse.home_office }}</p>
            <button class="govuk-button govuk-button--secondary" type="button"
              (click)="formBuilder.clearAwsLookup(formId, field.field)">
              Clear
            </button>
          </div>
        </div>
        } @else { @if (field.type === 'date') {
        <input [id]="field.field" [type]="field.type" [ariaRequired]="field.required"
          formControlName="{{ field.field }}"
          [attr.max]="field.hide_dates_in_future ? today : null"
          [attr.min]="field.hide_dates_in_past ? today : null"
          [attr.aria-describedby]="describedBy(field)" [attr.aria-invalid]="showErrors(field['field']) ? true : null"
          [ngClass]="{ 'govuk-input': true, 'govuk-input--error': !form.pristine && form.get(field.field)?.touched && form.get(field.field)?.errors }" />
        } @else {


        <input *ngIf="!field.resource_lookup && !field.resource_dropdown" [id]="field.field" [type]="getInputType(field)" [ariaRequired]="field.required"
          formControlName="{{ field.field }}"
          [attr.aria-describedby]="describedBy(field)" [attr.aria-invalid]="showErrors(field['field']) ? true : null"
          [ngClass]="{ 'govuk-input': true, 'govuk-input--error': !form.pristine && form.get(field.field)?.touched && form.get(field.field)?.errors }" />
        }

        <ng-container *ngIf="field.resource_lookup">
          <div class="govuk-form-group resource-lookup">
            <!-- <h2 class="govuk-label-wrapper">
              <label class="govuk-label govuk-fieldset__legend--m govuk-label--m--inverse" [for]="field.field">
                {{ displayTitle(field) }}
              </label>
            </h2> -->

            <div class="govuk-input__wrapper">
              <input class="govuk-input govuk-input--with-clear" type="text" [id]="field.field"
                formControlName="{{ field.field }}" placeholder="Start typing to search..." autocomplete="off"
                [attr.aria-required]="field.required ? 'true' : null"
                [attr.aria-describedby]="describedBy(field)" [attr.aria-invalid]="showErrors(field['field']) ? true : null"
                (input)="onSearch($event, field, appConfig)" />

              <div *ngIf="searchText" role="button" tabindex="0" class="govuk-input__suffix"
                (click)="clearSearch(field)" (keydown.enter)="clearSearch(field)" (keydown.space)="clearSearch(field)">
                <b aria-hidden="true">×</b>
              </div>
            </div>

            <span *ngIf="field.searching" class="govuk-hint">Searching…</span>
            <span *ngIf="field.noResults" class="govuk-hint">No results found</span>

            <!-- Suggestions dropdown -->
            <ul *ngIf="suggestions?.length" class="resource-suggestions" role="listbox">
              <li *ngFor="let suggestion of suggestions" role="option" tabindex="0" class="resource-suggestion"
                (click)="selectSuggestion(suggestion, field)" (keydown.enter)="selectSuggestion(suggestion, field)">
                <img src="./assets/images/search.svg" alt="" />
                {{ suggestion.pretty_name || suggestion.venue_name }}
              </li>
            </ul>

            <!-- Selected resource -->
            <div *ngIf="field.answer && field.selected_resource?.description">
              <p class="govuk-label govuk-fieldset__legend--m pt-3">Description</p>
              <p>{{ field.selected_resource.description }}</p>
              <img class="selected-venue" *ngIf="field.selected_resource.image" [src]="field.selected_resource.image"
                alt="" />
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="field.resource_dropdown">
          <select class="govuk-select govuk-select--inverse" [id]="field.field" formControlName="{{ field.field }}"
            [attr.aria-required]="field.required ? 'true' : null" [attr.aria-describedby]="describedBy(field)"
            [attr.aria-invalid]="showErrors(field['field']) ? true : null" (change)="selectDropdownVenue($event, field)">
            <option value="">Please select</option>
            <option *ngFor="let venue of dropdownVenues(field)" [value]="venue.pretty_name || venue.venue_name">
              {{ venue.pretty_name || venue.venue_name }}
            </option>
          </select>
          <div *ngIf="field.venuesLoading" class="govuk-hint">Loading venues…</div>
          <span *ngIf="field.venuesError" class="govuk-error-message">Venues could not be loaded. Please try again later.</span>

          <div *ngIf="field.answer && field.selected_resource?.description">
            <p class="govuk-label govuk-fieldset__legend--m pt-3">Description</p>
            <p>{{ field.selected_resource.description }}</p>
            <img class="selected-venue" *ngIf="field.selected_resource.image" [src]="field.selected_resource.image"
              alt="" />
          </div>
        </ng-container>

        } }

        @if (field.type === 'textarea') {
        <textarea [id]="field.field" formControlName="{{ field.field }}" [ariaRequired]="field.required"
          [attr.aria-describedby]="describedBy(field)" [attr.aria-invalid]="showErrors(field['field']) ? true : null"
          [ngClass]="{
              'govuk-textarea': true,
              'govuk-textarea--error':
                form.get(field.field)?.invalid &&
                (form.get(field.field)?.touched || form.get(field.field)?.dirty)
            }"></textarea>
        }
      </ng-container>

      <ng-container *ngIf="field.type === 'checkbox'">
        <div class="govuk-form-group">
          <ng-container *ngIf="field.helptext">
            <div id="{{ field.field }}-hint" class="govuk-hint" [innerHTML]="field.helptext"></div>
          </ng-container>

          @if (showErrors(field['field'])) {
          <p id="{{ field['field'] }}-error" class="govuk-error-message" role="alert">
            <span class="govuk-visually-hidden">Error:</span>
            {{ getErrorMessage('required', field['field']) }}
          </p>
          }

          <div class="govuk-checkboxes">
            <div class="govuk-checkboxes__item">
              <input class="govuk-checkboxes__input" id="{{ field['field'] }}" type="checkbox"
                formControlName="{{ field['field'] }}" [attr.aria-describedby]="describedBy(field)"
                [attr.aria-required]="field['required'] ? 'true' : null"
                [attr.aria-invalid]="showErrors(field['field']) ? true : null" />
              <label class="govuk-label govuk-checkboxes__label govuk-label--m--inverse" for="{{ field.field }}">
                {{ displayTitle(field) }}
                <ng-container *ngIf="field.required && showRequiredAsterisk"> *</ng-container>
              </label>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="field.type === 'radio'">
        <div class="govuk-form-group">
          <fieldset class="govuk-fieldset" [attr.aria-required]="field.required"
            [attr.aria-describedby]="describedBy(field)">
            <legend class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m-inverse">
              {{ displayTitle(field) }}
              <ng-container *ngIf="field.required && showRequiredAsterisk"> *</ng-container>
            </legend>

            <ng-container *ngIf="field.helptext">
              <div id="{{ field.field }}-hint" class="govuk-hint" [innerHTML]="field.helptext"></div>
            </ng-container>

            @if (showErrors(field['field'])) {
            <p id="{{ field['field'] }}-error" class="govuk-error-message" role="alert">
              <span class="govuk-visually-hidden">Error:</span>
              {{ getErrorMessage('required', field['field']) }}
            </p>
            }

            <div class="govuk-radios">
              @for (option of field.radio_options; track $index) {
              <div class="govuk-radios__item">
                <input class="govuk-radios__input" type="radio" [value]="option.value"
                  formControlName="{{ field.field }}" id="{{ field.field }}_{{ option.value }}"
                  [attr.aria-required]="field.required ? 'true' : null" />
                <label class="govuk-label govuk-radios__label" for="{{ field.field }}_{{ option.value }}">
                  {{ option.title }}
                </label>
              </div>
              }
            </div>
          </fieldset>
        </div>
      </ng-container>

      <ng-container *ngIf="field.type === 'dropdown'">
        <p class="govuk-label-wrapper">
          <label class="govuk-label govuk-label--m govuk-label--m--inverse" [for]="field.field">
            {{ displayTitle(field) }}
            <ng-container *ngIf="field.required && showRequiredAsterisk"> *</ng-container>
          </label>
        </p>

        <ng-container *ngIf="field.helptext">
          <div id="{{ field.field }}-hint" class="govuk-hint" [innerHTML]="field.helptext"></div>
        </ng-container>

        @if (showErrors(field['field'])) {
        <p id="{{ field['field'] }}-error" class="govuk-error-message" role="alert">
          <span class="govuk-visually-hidden">Error:</span>
          {{ getErrorMessage('required', field['field']) }}
        </p>
        }

        <select class="govuk-select govuk-select--inverse" id="{{ field['field'] }}" formControlName="{{ field['field'] }}"
          [attr.aria-required]="field['required']" [attr.aria-describedby]="describedBy(field)"
          [attr.aria-invalid]="showErrors(field['field']) ? true : null">
          <option value="">Please select</option>
          <ng-container *ngFor="let opt of field.options">
            <option *ngIf="opt.visible" [value]="opt.value">
              {{ opt.title }}
            </option>
          </ng-container>
        </select>
      </ng-container>

      <ng-container *ngIf="
          field.type === 'heading' &&
          field.component_type !== 'govbook-information_box' &&
          field.component_type !== 'govbook-warning_box' &&
          field.component_type !== 'body'
        ">
        <h2 class="govuk-heading-m govuk-heading-m--inverse">
          {{ displayTitle(field) }}
        </h2>
        <ng-container *ngIf="field.helptext">
          <div id="{{ field.field }}-hint" class="govuk-hint" [innerHTML]="field.helptext"></div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="field.type === 'heading' && field.component_type === 'govbook-warning_box'">
        <div class="warning-box">
          <div class="content">
            <h2 class="warning-box__title">{{ displayTitle(field) }}</h2>
            <span class="warning-box__message" [innerHTML]="contentHtml(field.component_text)"></span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="field.type === 'heading' && field.component_type === 'govbook-information_box'">
        <div class="information-box">
          <div class="content">
            <h2 class="information-box__title">{{ displayTitle(field) }}</h2>
            <span class="information-box__message" [innerHTML]="contentHtml(field.component_text)"></span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="field.type === 'heading' && field.component_type === 'body'">
        <div class="govuk-body govuk-body--inverse" [innerHTML]="contentHtml(field.component_text)"></div>
      </ng-container>

      <ng-container *ngIf="field.type === 'submit'">
        <ng-container *ngIf="field.helptext">
          <div id="{{ field.field }}-hint" class="govuk-hint" [innerHTML]="field.helptext"></div>
        </ng-container>
        <div *ngIf="showSubmit">
          <button class="nhsuk-button govuk-button" type="button" (click)="submit()">
            {{ displayTitle(field) }}
          </button>
        </div>
      </ng-container>

    </ng-container>
  </div>

  @if (inlineRequiredCheckboxWarning && field === lastVisibleRequiredCheckboxField && showRequiredCheckboxWarning) {
  <div class="warning-box">
    <div class="content">
      <h2 class="warning-box__title">Important</h2>
      <span class="warning-box__message">
        {{ checkboxWarningMessage }}
      </span>
    </div>
  </div>
  }

  }
  }

  <div class="warning-box" *ngIf="!inlineRequiredCheckboxWarning && showRequiredCheckboxWarning">
    <div class="content">
      <h2 class="warning-box__title">Important</h2>
      <span class="warning-box__message">
        {{ checkboxWarningMessage }}
      </span>
    </div>
  </div>

  <button type="button" class="btn btn-primary" *ngIf="showSubmit" (click)="submit()">
    Continue
  </button>

</form>
}
